import { DecisionMakerProfile as DecisionMakerProfileBase } from './entryPoint';

export const DecisionMakerProfile = DecisionMakerProfileBase;
